// Copy for the empty state of each new surface.
//
// An empty bank on day one is the common case, not the edge case. These strings
// are what the components render and what the tests assert — split out so
// `node --test` can cover them without jsdom.

export const EMPTY_BANK =
  'The bank is empty. Accounts land here when the door creates them or a strategist returns one.';

export const EMPTY_QUEUE =
  'No picks or requests waiting. The morning top-up and strategist requests land here.';

export const EMPTY_QUEUE_STRIP =
  'Bank: 0 accounts · 0 ready · 0 new today · age unknown';

export const EMPTY_ACTIONS =
  'No actions on this account. Request is for the bank; return and snooze are for the owner.';

export const EMPTY_CHAT =
  'Ask Scout what to know about this account before reaching out.';

// An AE's account chat (`lib/roleViews.ts` scoutStarters 'ae'): about the deal, not outreach.
export const EMPTY_CHAT_AE =
  'Ask Scout where this deal stands, what was last discussed, or what to prepare for the next meeting.';

// Leadership's and viewers' account chat on the oversight page (scoutStarters 'oversight').
export const EMPTY_CHAT_OVERSIGHT =
  'Ask Scout who is working this account, what has happened lately, or where its deals stand.';

export const EMPTY_CHAT_UNSCOPED =
  'Ask Scout about your book or the available accounts.';
